/** Shared React Query options for BudgetTrack — avoids retry storms on 429/403. */
export const budgetTrackQueryOptions = {
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
  staleTime: 60_000,
  retry: (failureCount, error) => {
    const status = error?.response?.status;
    if (status === 429 || status === 401 || status === 403 || status === 404) {
      return false;
    }
    return failureCount < 1;
  },
};
